import actions from './actions'
import { factoryReducer } from '../factory'

const initialState = {
  id: '',
  name: '',
  role: 'Provider',
  email: '',
  avatar: '',
  forgetPasswordState: 'initial',
  authorized: false,
  loading: false,
  forgetPasswordLoading: false,
  forgetPasswordUsername: '',
  newPassReq: false,
  details: {},
  emailVerifyLoading: false,
  emailVerifyCodeLoading: false,
  inviteModalLoading: false,
  inviteModalVisible: false,
  assignModalLoading: false,
  assignModalVisible: false,
  assignMemberID: '',
  shareModalVisible: false,
  shareModalLoading: false,
  shareMemberID: false,
  linkedProviders: [],
  linkedProvidersModalLoading: false,
  linkedProvidersModalVisible: false,
  OTPReq: false,
  retainedValues: {
    email: '',
    password: '',
  },
  pendingApprovalUsers: [],
  pendingApprovalTotal: 0,
  pendingApprovalOffset: 0,
  pendingApprovalLimit: 50,
  pendingApprovalLoading: false,
}

export default factoryReducer(initialState, actions)
